import { ArrowLeft } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";

/**
 * BackButton — flecha de "regresar" universal.
 * - Si el navegador tiene historial (window.history.length > 1) hace back().
 * - Si no, navega al fallback prop (por defecto "/").
 *
 * Uso:
 *   <BackButton />                    // regresa 1 paso o va a /
 *   <BackButton to="/dashboard" />    // fallback específico
 *   <BackButton label="Al inicio" />  // texto custom
 */
export default function BackButton({ to = "/", label = "Atrás", className = "", testid = "back-btn" }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    // Prefer history.back if there's actual navigation history within this app
    if (typeof window !== "undefined" && window.history.length > 1 && document.referrer && document.referrer.includes(window.location.host)) {
      navigate(-1);
    } else {
      navigate(to);
    }
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      data-testid={testid}
      className={
        "inline-flex items-center gap-1.5 text-sm font-semibold text-neutral-600 hover:text-black transition-colors rounded-full px-3 py-1.5 hover:bg-neutral-100 " +
        className
      }
      aria-label={label}
    >
      <ArrowLeft className="w-4 h-4" />
      <span>{label}</span>
    </Link>
  );
}
